import { render, staticRenderFns } from "./AssetPersons.vue?vue&type=template&id=40a933a4"
import script from "./AssetPersons.vue?vue&type=script&lang=js"
export * from "./AssetPersons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports